<!-- 企业信息 -->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Head>
          <template v-slot:title>
            <span style="margin-left:30%;">调查问卷</span>
          </template>
        </Head>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" style="margin-top:20px;">
      <el-col :span="16">
        <el-card class="box-card">
          <div class="text item">
            <!--            <el-row>-->
            <!--              <el-col :span="5">-->
            <!--                <el-input-->
            <!--                    placeholder="请输入企业名称"-->
            <!--                    v-model="enterprise">-->
            <!--                  <i slot="prefix" class="el-input__icon el-icon-search"></i>-->
            <!--                </el-input>-->
            <!--              </el-col>-->
            <!--              <el-col :span="19">-->
            <!--                <el-button style="margin-left: 20px" type="primary theme-btn" class="btn" @click.native="searchRole">-->
            <!--                  查询-->
            <!--                </el-button>-->
            <!--                <el-button type="info" class="btn" @click.native="reset">重置</el-button>-->
            <!--              </el-col>-->
            <!--            </el-row>-->
            <!-- 表格 -->
            <el-table style="width: 100%" :data="EnterpriseeData" class="table-content">
              <el-table-column align="center" width="100" label="编号" :fit="true" type="index"></el-table-column>
              <el-table-column align="center" width="300" show-overflow-tooltip label="您对油地直聘小程序的满意度" prop="questionOne"
                               :formatter="stateFormat"></el-table-column>
              <el-table-column align="center" width="300" show-overflow-tooltip label="您对油地直聘小程序的满意度" prop="questionTwo"
                               :formatter="stateFormat1"></el-table-column>
              <el-table-column align="center" label="意见反馈" show-overflow-tooltip prop="feedback"></el-table-column>
              <el-table-column align="center" label="提交人" prop="userName"></el-table-column>
            </el-table>
          </div>
          <div class="pagelist" style="text-align: center">
            <el-row type="flex" justify="center">
              <el-col :span="24" class="nomore" style="margin-top:24px;">
                <!-- <span v-if="isShow">没有更多了</span> -->
                <el-pagination
                    class="page"
                    background
                    :current-page="currentPage"
                    @current-change="current_page"
                    layout="total, prev, pager, next, jumper"
                    :total="dataNumber">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </el-card>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import Head from '@/components/header/head.vue';

export default {
  name: "company",
  components: {
    Head,
  },
  data() {
    return {
      page: 1,
      size: 10,
      EnterpriseeData: "",
      currentPage: 1,
      dataNumber: 0,
      surveyName: "", // 搜索名称
    }
  },
  created() {
    this.getsurvey(this.page, this.size, this.surveyName)
  },
  mounted() {
  },
  methods: {
    // 重置搜索数据
    reset() {
      this.currentPage = 1
      this.getLibrary(1, 10, '')
    },
    // 查询
    searchRole() {
      this.getLibrary(this.page, this.size, this.surveyName)
    },
    // 获取调查问卷数据
    getsurvey(page, size, name) {
      this.axiosGet(`/survey/page/${page}/${size}`, {}).then((res) => {
        if (res.code == 200) {
          this.EnterpriseeData = res.data.list
          this.dataNumber = res.data.total
        }
      })
    },
    // 第一个问题的转换
    stateFormat(row, column) {
      if (row.status === 1) {
        return "非常满意";
      } else if (row.status === 2) {
        return "满意";
      } else if (row.status === 3) {
        return "不太满意";
      } else if (row.status === 4) {
        return "不满意";
      }
    },
    // 第二个问题
    stateFormat1(row, column) {
      if (row.status === 1) {
        return "非常满意";
      } else if (row.status === 2) {
        return "满意";
      } else if (row.status === 3) {
        return "不太满意";
      } else if (row.status === 4) {
        return "不满意";
      }
    },
    //分页
    current_page(currentPage) {
      this.page = currentPage
      this.getsurvey(this.page, this.size, '')
    },
    // 跳转企业详情
    todetails(val) {
      this.$router.push({
        name: "Businessdetails",
        params: {
          id: val.id,
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.newsList-box {
  width: 100%;

  .newsItemBox {
    transition: .2s;
    padding-left: 30px;
    display: flex;
    justify-content: space-between;

    .title-Top {
      line-height: 60px;
      color: black;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 220px;

    }

    .companyNature {
      line-height: 60px;
      color: black;
      width: 100px;
      text-align: center;
    }

    .BelongingContent {
      line-height: 60px;
      width: 120px;
      color: black;
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .updateTime {
      line-height: 60px;
    }

    .content-bottom {
      line-height: 60px;
      margin-right: 30px;
    }
  }

  .newsItemBox:hover {
    box-shadow: 0px 3px 19px 5px rgba(42, 112, 255, 0.13);
  }
}

// 分页
.box-card {
  .box-top {
    padding: 36px 32px 0 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    .sendNewsBtn {
      width: 136px;
      height: 48px;
      border: 2px solid #1A80FC;
      border-radius: 8px;
      background: #fff;
      color: #1A80FC;
    }
  }

}


</style>
